export default __webpack_public_path__ + "static/media/DB_5.4e258ffd.png";